import { PlusOutlined } from "@ant-design/icons"
import { Button, Form, InputNumber, Row, Select, Space } from "antd"
import { useMemo, useState } from "react"
import { InfoCard } from "../../UnitPanel/components/common/InfoCard"
import { Node } from "@antv/x6"
import { cellToNodeState } from "@/components/FlowSheetEditor/services/storage"
import { NodeState, NozzleRecord } from "@/components/FlowSheetEditor/services/modal"
import { PortTypes } from "@/components/FlowSheetEditor/constant"
import { v4 as uuidv4 } from "uuid";
import { NozzleType } from "@/types/common"
import { useGraphInstance } from "@antv/xflow"
import { EditableNozzleTable } from "./NozzleTable"

interface FCustomNozzleProps {
  node: Node
}

export const FCustomNozzles = (props: FCustomNozzleProps) => {
  const {node} = props;
  const nodeState = cellToNodeState(node)
  const graph = useGraphInstance()
  const [value, setValue] = useState<NozzleRecord[]>(nodeState.customNozzles || [])
  const [showEditor, setShowEditor] = useState(false)
  const [form] = Form.useForm()

  const templates = useMemo(() => {
    const data = node.getData() as NodeState
    return (data.equipment?.nozzleTemps || []).map(item => {
      return {label: item.name, value: item.simCode, direction: item.direction}
    })
  }, [node])

  const onSave = (values) => {
    const {x,y, name} = values
    const targetTemp = templates.find(item => item.value === name)!;
    const newNodeState = cellToNodeState(graph?.getCellById(node.id) as Node)
    const customNozzles = (newNodeState.customNozzles || []).filter(item => new RegExp(`^${name}\\d`).test(item.name))
    const newItem: NozzleRecord = {
      name: `${name}${customNozzles.length}`,
      direction: targetTemp.direction,
      layout: {x, y},
      group: PortTypes.NozzlePort,
      id: uuidv4(),
      type: NozzleType.CustomFlowNozzle
    }
    node.addPort({
      id: newItem.id,
      group: PortTypes.NozzlePort,
      data: newItem,
      args: {x, y}
    })
    setValue([...value, newItem])
    onCancel()
  }

  const onCancel = () => {
    form.resetFields()
    setShowEditor(false)
  }

  const onChange = () => {
    const node = graph?.getCellById(nodeState.id) as Node
    if (node) {
      const newState = cellToNodeState(node)
      setValue(newState.customNozzles || [])
    }
  }
  
  return <InfoCard title={'Custom Nozzles'} action={<Button icon={<PlusOutlined />} onClick={() => setShowEditor(true)}/>}>
  <EditableNozzleTable nozzles={value} node={node} onChange={onChange} />
  {showEditor && <div className="mt-1">
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item
          name='name'
          label='Group Name'
          rules={[
            {
              required: true,
              message: 'Select a nozzle group',
            },
          ]}
        >
          <Select options={templates} />
        </Form.Item>
        <Form.Item
          name='x'
          label='X'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2}  />
        </Form.Item>
        <Form.Item
          name='y'
          label='Y'
          rules={[
            {
              required: true,
            },
          ]}
        >
          <InputNumber controls={false} min={-1} max={2} />
        </Form.Item>

        <Row justify={'end'} className="mt-2">
          <Space>
            <Button htmlType="button" onClick={() => onCancel()}>Cancel</Button>
            <Button type="primary" htmlType="submit">Save</Button>
          </Space>
        </Row>
    </Form>
  </div>}
  </InfoCard>
}